class AuthorizationPaths {
  static BASE_PATH = "/authorization";
  static LOGIN = AuthorizationPaths.BASE_PATH + "/login";
  static VERIFY = AuthorizationPaths.BASE_PATH + "/verify";
  static REG = AuthorizationPaths.BASE_PATH + "/reg";
  static FINALY_REG = AuthorizationPaths.REG + "/finaly";
  static RESTORE = AuthorizationPaths.BASE_PATH + "/restorePassword";
  static CHANGE_PASSWORD = AuthorizationPaths.BASE_PATH + "/changePassword";
}
class ProfilePaths {
  static BASE_PATH = "/lk" + "/profile";
}

class LkPaths {
  static BASE_PATH = "/lk";
  static PROFILE = ProfilePaths;
  static GOODS = LkPaths.BASE_PATH + "/goods";
  static PRODUCT = (productId: number | string) =>
    this.GOODS + `/product/${productId}`;
  static EXPORT = LkPaths.BASE_PATH + "/export";
  static EXPORT_TASK = (taskId: string) => this.EXPORT + `/tasks/${taskId}`;
  static CONVERTER = LkPaths.BASE_PATH + "/converter";
  static API_DOCS = LkPaths.BASE_PATH + "/api-docs";
  static API_KNOWLEDGE_BASE = LkPaths.BASE_PATH + "/knowledge-base";
  static SCANNER = LkPaths.BASE_PATH + "/scanner";
  static SUBSCRIBE = LkPaths.BASE_PATH + "/subscribe";
  static SUBSCRIBE_OLD = LkPaths.BASE_PATH + "/subscribe_old";
  static SERVICE_STATUS = LkPaths.BASE_PATH + "/service-status";
  static CLIENT_ORDERS = (client: string) =>
    this.BASE_PATH + `/orders/${client}`;
}
class AdminPaths {
  static BASE_PATH = "/admin";
  static CLIENT_PAGE = (userId: string) =>
    AdminPaths.BASE_PATH + `/clients/${userId}`;
}
export class RoutesPaths {
  static LANDING = "/";
  static OUTSOURCING = "/outsourcing";
  static OFFER = "/offer";
  static PRIVACY = "/privacy";
  static AUTH = AuthorizationPaths;
  static ADMIN = AdminPaths;
  static LK = LkPaths;
}
